import {
  DEFECT_MODULE_LIST_PIN_LEVELS,
  resolvePinnedVirtualScrollHeader,
  resolvePinnedVirtualScrollHierarchyMap
} from '@/ui/utils/resolvePinnedVirtualScrollHeaders';

/** @returns {object|null} 고정할 string_header row */
export function resolvePinnedStringHeaderRow(params) {
  const stringLevel = DEFECT_MODULE_LIST_PIN_LEVELS.find((level) => level.id === 'string');
  return resolvePinnedVirtualScrollHeader(stringLevel, params);
}

/** @returns {object|null} 고정할 array_header row */
export function resolvePinnedArrayHeaderRow(params) {
  const arrayLevel = DEFECT_MODULE_LIST_PIN_LEVELS.find((level) => level.id === 'array');
  return resolvePinnedVirtualScrollHeader(arrayLevel, params);
}

/** @returns {{ arrayRow: object|null, stringRow: object|null }} */
export function resolvePinnedDefectHierarchyRows(params) {
  const map = resolvePinnedVirtualScrollHierarchyMap(DEFECT_MODULE_LIST_PIN_LEVELS, params);
  return {
    arrayRow: map.array ?? null,
    stringRow: map.string ?? null
  };
}
